import { useToggle } from "client/hooks/utils/useToggle";
import { translateFunc } from "client/utils/translateFunc";
import { BoldIcon } from "components/common/Icons/BoldIcon";
import { Popup } from "components/common/Popup/Popup";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { TextDecorationContent } from "./TextDecorationContent/TextDecorationContent";

interface TextDecorationProps {
    textBoxId: string;
}

export const TextDecoration = ({ textBoxId }: TextDecorationProps) => {
    const { isOpen, toggle, onClose: close } = useToggle();
    return (
        <Popup isOpen={isOpen} close={close} content={<TextDecorationContent textBoxId={textBoxId} />}>
            <ToolTip text={translateFunc("text-decoration")}>
                <button
                    className={`w-10 h-10 flex items-center justify-center ${
                        !isOpen && "hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
                    } ${isOpen ? "bg-irGray-200 dark:bg-darkSurface-300" : "bg-transparent"} rounded-lg`}
                    onClick={toggle}
                >
                    <BoldIcon />
                </button>
            </ToolTip>
        </Popup>
    );
};
